<template>
  <div
    v-if="show"
    data-dialog-backdrop="modal"
    data-dialog-backdrop-close="true"
    class="pointer-events-auto fixed inset-0 z-[999] grid h-screen w-screen place-items-center bg-black bg-opacity-60 backdrop-blur-sm transition-opacity duration-300"
    @click.self="handleClose"
  >
    <div
      data-dialog="modal"
      class="relative m-4 p-4 w-4/5 min-w-[80%] max-w-[80%] rounded-lg bg-white shadow-sm"
    >
      <button
        class="button transparent compact close-button z-[999]"
        @click="handleClose"
      >
        <fluent-icon
          icon="dismiss"
          size="24"
          class="text-black-900 dark:text-slate-50"
        />
      </button>
      <div
        class="relative border-t border-slate-200 py-4 leading-normal text-slate-600 font-light"
      >
        {{ displayText() }}
      </div>
      <div class="flex shrink-0 flex-wrap items-center justify-center">
        <a
          :href="actionLink()"
          target="_blank"
          class="action-btn rounded-md font-medium px-5 py-2 cursor-pointer"
          :style="{
            background: widgetColor,
            color: textColor,
          }"
        >
          <span>{{ channel.value }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { getContrastingTextColor } from '@chatwoot/utils';
import { mapGetters } from 'vuex';
import FluentIcon from 'shared/components/FluentIcon/Index.vue';

export default {
  name: 'ContactChannelActionModal',
  components: { FluentIcon },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
    channel: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      widgetColor: 'appConfig/getWidgetColor',
    }),
    textColor() {
      return getContrastingTextColor(this.widgetColor);
    },
  },
  methods: {
    displayText() {
      const { display_text, default_text } = this.channel;
      const text =
        !display_text ||
        display_text === '' ||
        display_text === 'null' ||
        display_text === 'undefined'
          ? default_text
          : display_text || default_text;
      return text.replace('{{input_value}}', this.channel.value);
    },
    actionLink() {
      if (this.channel.action_link) {
        return this.channel.action_link.replace(
          '{{input_value}}',
          this.channel.value
        );
      }
      return '';
    },
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>
<style scoped>
.close-button {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
</style>
